import img2a from "../img/news/news02.jpg"
import img2b from "../img/news/news02-1.jpg"
import img3a from "../img/news/news03.jpg"
import img3b from "../img/news/news03-1.jpg"
import img4a from "../img/news/news04.jpg"
import img4b from "../img/news/news04-1.jpg"
import img5a from "../img/news/news05.jpg"
import img5b from "../img/news/news05-1.jpg"
import img6a from "../img/news/news06.jpg"
import img6b from "../img/news/news06-1.jpg"
import img7a from "../img/news/news07.jpg"


const NewsData = [
   {  // index. 1
      title: "[LCDC]   LCDC SEOUL ADVENT CALENDAR 2022 EDITION",
      date: "2022-02-18",
      imgUrl1: img2a,
      content1: "LCDC SEOUL 오픈 1주년 기념 리미티드 에디션",
      content2: "LCDC Seoul Advent Calendar 2022 Edition을 선보입니다. 성탄절을 기다리며 선물이 담긴 달력 칸을 하나씩 꺼내어 랜덤의 선물을 열어 보는 이색적인 달력 ‘어드벤트 캘린더’. 그 안에 저마다의 크고 작은 이야기를 가진 브랜드들이 모여있는 공간 플랫폼 LCDC SEOUL을 담았습니다.",
      imgUrl2: img2b,
      content3: "1년 12개월, 한 해를 함께 해온 브랜드 중 LCDC 자체 브랜드 르콩트 드콩트(LE CONTE DES CONTES) 외 12개 브랜드가 참여하여 브랜드마다의 힘과 색을 더한 스토리 오브 스토리즈(Story of Stories) 컨셉으로 만나 볼 수 있습니다.",
      span1:
         "참여 브랜드 I LCDC 자체 브랜드 르콩트 드콩트(LE CONTE DES CONTES), 이페메라(EPHEMERA), 바 포스트스크립트(BAR POSTSCRIPT)와 함께 오이뮤(OIMU), 한아조(HANAHZO), 르시뜨피존(LE SITE PIGEON), 쿠오카(KUOCA), 삭스타즈(SOCKSTAZ), 오뚜기(OTTOGI), 앙봉꼴렉터(UN BON COLLECTOR), 뚜까따(TUKATA), 샹프리(SHANGPREE), 조르단(JORDAN)",
      span2:
         "#collectLCDC  I  2022.11.11.FRI ~2022.11.24.THU",
      span3:
         "해당기간 구매고객 대상 비누선물 세트를 드립니다.",
   },
   {  // index. 2
      title: "[LCDC]   STORE OPEN: SHINSEGAE GANGNAM",
      date: "2022-02-16",
      imgUrl1: img3a,
      content1: "저마다의 이야기를 가진 크고 작은 브랜드들이 모여 있는 공간 플랫폼 LCDC",
      content2: "컨템포러리 라이프스타일 편집숍 SHOP LCDC 가 신세계백화점 강남점에 새로운 매장을 오픈하였습니다.",
      imgUrl2: img3b,
      content3: "SHOP LCDC가 큐레이션 하는 바잉 브랜드와 LECONTE 가을-겨울 신상품을 만나실 수 있으니 지금 방문해 확인하세요!",
      span1:
         "✔ ADDRESS: 서울시 서초구 신반포로 176(반포동) 5층 뉴컨템포러리존",
      span2:
         "✔ Mon ~ Sun 10:30~20:00",
      span3:
         "✔ TEL. 02-3479-1239",
   },
   {  // index. 3
      title: "[LCDC SEOUL]   THANKS GIVING DAY HOLIDAY NOTICE",
      date: "2022-02-09",
      imgUrl1: img4a,
      content1: "[LCDC SEOUL 전체 휴무 안내]",
      content2: "LCDC SEOUL은 추석 연휴인 9/9(금), 9/10(토) 이틀 동안 쉬어 갑니다.",
      imgUrl2: img4b,
      content3: "LCDC SEOUL을 찾아주시는 여러분 모두 풍요로운 추석 연휴 보내시길 바랍니다.",
      span1:
         "*ADDRESS: 서울시 성동구 연무장17길 10",
   },
   {  // index. 4
      title: "[LE CONTE DES CONTES]   UN BON COLLECTOR POP-UP",
      date: "2022-02-07",
      imgUrl1: img5a,
      content1: "[UN BON COLLECTOR POP-UP AT FLAGSHIP STORE 앙 봉 꼴렉터 팝업 스토어 오픈]",
      content2: "르콩트 드콩트 플래그쉽 스토어에서 확고한 취향의 아이템을 큐레이션 하는 앙 봉 꼴렉터의 팝업 스토어를 진행 중입니다.",
      imgUrl2: img5b,
      content3: "UN BON COLLECTOR(앙 봉 꼴렉터)는 A good collector라는 뜻으로 두 자매의 확고한 취향과 안목이 반영된 컬렉션입니다. 앙 봉 꼴렉터는 자신의 철학과 애정이 담긴 작품을 만드는 디자이너와 아티스트를 찾아 그들의 개성 있는 아름다움을 전달하며 이러한 예술가들이 힘을 믿으며 지지하고 있습니다. ‘사다’가 아니라 ‘수집하다’의 의미로 예술이 일상 속으로 들어가 삶의 가치를 한층 더 높이고 새로운 영감이 되기를 희망합니다.",
      span1:
         "▷ 앙 봉 꼴렉터 6주년 굿즈 출시, ▷ 피으 신제품 출시",
      span2:
         "📌 POP-UP DATE: 2022.05.05-06.01",
      span3:
         "📌 LOCATION: LE CONTE DES CONTES / LCDC SEOUL A동 2F (서울시 성동구 연무장로17길 10)",
   },
   {  // index. 5
      title: "[LE CONTE DES CONTES]   DUEX GARÇON X LE CONTE DES CONTES CANDLE POT 2차 예약 안내",
      date: "2022-02-03",
      imgUrl1: img6b,
      content1: "[두갸르송 x 르콩트 드콩트] CANDLE POT 콜라보레이션 캔들 팟",
      content2: "식물을 직접 키우며 가장 아껴줄 수 있는 화분을 만들고자 시작된 두갸르송은 식물을 생각하는 그 소중한 마음이 화분마다 묻어나 있습니다. 두갸르송 화분은 작가가 유학 시절 발견한 프랑스 니스의 자연스럽고 아름다운 생활 속 가드닝을 닮아 자연에 가까우면서도 특별한 미감과 취향이 집약되어 있습니다. 계절에 따른 분위기, 공간에 따른 분위기, 사람에 따른 분위기 등 어떤 분위기가 변한다는 것은 어쩌면 그 향이 변화하는 것일지 모릅니다. 르콩트 드콩트의 두갸르송 콜라보레이션 캔들 팟에 담긴 향의 이야기가 만들어내는 각각의 분위기를 발견할 수 있습니다. ",
      imgUrl2: img6a,
      content3: "식물의 뿌리가 가장 건강하게 숨 쉴 수 있는 화분을 위한 점토를 고르고, 두갸르송만의 미감과 만듦새로 모양을 잡아 디자인하고 있습니다. 판매의 목적 이전에 식물을 소중히 다루고 싶은 마음을 유지하기 위해, 두갸르송이 생각하는 가장 완벽한 화분을 만들고 있어 한정 수량으로 제작되고 있습니다. 인투 더 우즈(블랙), 굿 애프터 레인(그린), 모닝 미스트(화이트) / 각기 다른 세 가지 향의 이야기가 만들어내는 분위기를 발견해보세요.",
      span1:
         "- 캔들 팟 크기 : 외경 지름 81mm / 높이 80mm. (수작업으로 제작되어 사이즈가 상이할 수 있습니다.)",
      span2:
         "- 캔들 팟 컬러 : 유약 컬러가 독특하게 발현된 캔들 팟 제품도 있으며, 매장에서 실물 확인하시고 구매 가능합니다.",
      span3:
         "-캔들 성분: Natural ingredients (Soy wax/Beeswax)",
   },
   {  // index. 6 
      title: "[BAR POSTSCRIPT]   COVID OPENING HOUR NOTICE",
      date: "2021-10-28",
      imgUrl1: img7a,
      content1: "사회적 거리두기 강화로 인하여 Bar POSTSCRIPT 영업시간이 변경되었습니다.",
      content2: "*12/17 까지 : 17:00 PM ~ 00:00 AM (Last Order: 23:30 / 음식 및 음료 전 메뉴)",
      content3: "*12/18 이후 : 16:00 PM ~ 21:00 PM (Last Order: 20:30 / 음식 및 음료 전 메뉴)",
      span1:
         "12/18일부터 Bar P.S 는 방역 지침에 따라 백신 접종 완료자 4명까지 이용 가능합니다. 미 접종자는 이용이 어려운 점 양해 부탁 드립니다.",
      span2:
         "미리 예약하신 분들께는 운영 시간 내에서 변경 가능하도록 따로 연락 드릴 예정 입니다.",
      span3:
         "자세한 문의는 02-3409-5974 로 연락 주십시오. (유선문의는 영업시작 1시간 전부터 이용 가능합니다.)",
   },

]

export default NewsData
